import { PlusIcon, Sidebar, UpgradeBadge } from '@buffer-mono/popcorn'

import {
  useCurrentOrganization,
  useIsAdmin,
  useOneBufferBilling,
} from '~publish/contexts/AccountContext'
import { useIsAtPlanLimit } from '~publish/hooks/useIsAtPlanLimit'
import { useCta } from '~publish/hooks/useCta'

import styles from './ChannelNav.module.css'

export function NewChannelButton(): JSX.Element {
  const currentOrganization = useCurrentOrganization()
  const billing = useOneBufferBilling()
  const isAtPlanLimit = useIsAtPlanLimit()
  const isAdmin = useIsAdmin()

  const hasPaymentDetails = !!billing?.paymentDetails?.hasPaymentDetails
  const currentChannelQuantity = currentOrganization?.channels?.length ?? 0

  const { clicked: ctaClicked } = useCta(
    'community-sidebar-channels-addChannels-1',
    {
      upgradePathName: 'addChannel-upgrade',
      extraProperties: {
        currentChannelQuantity,
        isAtPlanLimit,
        hasPaymentDetails,
      },
    },
  )

  const openChannelStorefront = (): void => {
    ctaClicked()
    window.appshell?.actions?.openChannelStorefront({
      cta: 'community-sidebar-channels-newChannel-1',
    })
  }

  if (!isAdmin) {
    return <></>
  }

  return (
    <Sidebar.ListItem>
      <Sidebar.Button
        size="large"
        prefix={
          <span className={styles.icon}>
            <PlusIcon />
          </span>
        }
        suffix={isAtPlanLimit && <UpgradeBadge />}
        className={styles.newChannelButton}
        onClick={openChannelStorefront}
      >
        New Channel
      </Sidebar.Button>
    </Sidebar.ListItem>
  )
}
